/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Endpoint_Cost_Rate_NoteInputs */

const en_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, only for what you use. No monthly plan.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", only for what you use. No monthly plan." }])
			})
		}
	)
);

const zh_hans1_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}，只为实际用量付费。没有月度套餐。`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: "，只为实际用量付费。没有月度套餐。" }])
			})
		}
	)
);

const pt_br2_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, só pelo que você usar. Sem plano mensal.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", só pelo que você usar. Sem plano mensal." }])
			})
		}
	)
);

const es_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, solo por lo que usas. Sin plan mensual.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", solo por lo que usas. Sin plan mensual." }])
			})
		}
	)
);

const fr_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, seulement pour ce que vous utilisez. Aucun forfait mensuel.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", seulement pour ce que vous utilisez. Aucun forfait mensuel." }])
			})
		}
	)
);

const de_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, nur für das, was du nutzt. Kein Monatstarif.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", nur für das, was du nutzt. Kein Monatstarif." }])
			})
		}
	)
);

const ru_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, только за то, чем пользуетесь. Без ежемесячного тарифа.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", только за то, чем пользуетесь. Без ежемесячного тарифа." }])
			})
		}
	)
);

const it_endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, solo per ciò che usi. Nessun piano mensile.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", solo per ciò che usi. Nessun piano mensile." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "{rate}, only for what you use. No monthly plan." |
*
* @param {Endpoint_Cost_Rate_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_rate_note = /** @type {((inputs: Endpoint_Cost_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Endpoint_Cost_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Cost_Rate_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { rate: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Cost_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_cost_rate_note(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_cost_rate_note(inputs)
			if (locale === "es") return es_endpoint_cost_rate_note(inputs)
			if (locale === "fr") return fr_endpoint_cost_rate_note(inputs)
			if (locale === "de") return de_endpoint_cost_rate_note(inputs)
			if (locale === "ru") return ru_endpoint_cost_rate_note(inputs)
			if (locale === "it") return it_endpoint_cost_rate_note(inputs)
			return en_endpoint_cost_rate_note(inputs)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Cost_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_cost_rate_note.parts === "function" ? zh_hans1_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_cost_rate_note(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_cost_rate_note.parts === "function" ? pt_br2_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_cost_rate_note(inputs) }]
				if (locale === "es") return typeof es_endpoint_cost_rate_note.parts === "function" ? es_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: es_endpoint_cost_rate_note(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_cost_rate_note.parts === "function" ? fr_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: fr_endpoint_cost_rate_note(inputs) }]
				if (locale === "de") return typeof de_endpoint_cost_rate_note.parts === "function" ? de_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: de_endpoint_cost_rate_note(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_cost_rate_note.parts === "function" ? ru_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: ru_endpoint_cost_rate_note(inputs) }]
				if (locale === "it") return typeof it_endpoint_cost_rate_note.parts === "function" ? it_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: it_endpoint_cost_rate_note(inputs) }]
				return typeof en_endpoint_cost_rate_note.parts === "function" ? en_endpoint_cost_rate_note.parts(inputs) : [{ type: "text", value: en_endpoint_cost_rate_note(inputs) }]
			})
		}
	)
);